export const isOdd = (value: number): boolean => value % 2 === 1;
